import styled from 'styled-components'

export const TextNoResult = styled.p`
  font-size: 20px;
  text-align: center;
  color: #7D7D7D;
`
